// extracted by mini-css-extract-plugin
export default {"break":"Home-module--break--8MHNT","artists":"Home-module--artists--RvcSY"};